import { API_URL } from "../lib/constants";
import fetchWithRequestId from "./common";

export const getMyPools = (accessToken) => {
  return fetchWithRequestId(`${API_URL}/pools/me/`, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
    //TODO add API endpoint to get public pools only
  }).then((res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const getPublicPools = (accessToken) => {
  return fetchWithRequestId(`${API_URL}/pools/public/`, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
    //TODO add API endpoint to get public pools only
  }).then((res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const getNotJoinedPublicPools = (accessToken) => {
  return fetchWithRequestId(`${API_URL}/pools/public/notJoined`, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
    //TODO add API endpoint to get public pools only
  }).then((res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const joinPublicPool = (accessToken, id) => {
  return fetchWithRequestId(`${API_URL}/pools/join?id=${id}`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const approveUserPoolJoinRequest = (accessToken, userToPoolId) => {
  return fetchWithRequestId(`${API_URL}/pools/approve/${userToPoolId}`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const rejectUserPoolJoinRequest = (accessToken, userToPoolId) => {
  return fetchWithRequestId(`${API_URL}/pools/decline/${userToPoolId}`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const getPoolById = (accessToken, id) => {
  // console.log("ID is ", id);
  return fetchWithRequestId(`${API_URL}/pools/${id}`, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then(async (res) => {
    if (!res.ok) {
      return res.text().then((text) => {
        throw new Error(JSON.parse(text).message);
      });
    }
    const response = await res.json();
    return response;
  });
};

export const createCutPoolRequest = (accessToken, data) => {
  return fetch(`${API_URL}/pools/cutpool`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const getPoolsInTournament = (tId, accessToken) => {
  return fetchWithRequestId(`${API_URL}/pools/tournament/${tId}`, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const getUsersInPool = (pId, accessToken) => {
  return fetchWithRequestId(`${API_URL}/pools/${pId}/users`, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const getOldPoolUsers = (accessToken, poolId) => {
  return fetch(`${API_URL}/pools/old/${poolId}`, {
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      throw new Error(res.statusText);
    }
    return res.json();
  });
};

export const removeUserInPool = (pId, puId, accessToken) => {
  return fetchWithRequestId(`${API_URL}/pools/${pId}/users/${puId}`, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};

export const removePoolInTournament = (pId, accessToken) => {
  return fetchWithRequestId(`${API_URL}/pools/${pId}`, {
    method: "DELETE",
    headers: {
      Authorization: "Bearer " + accessToken,
      "Content-Type": "application/json",
    },
  }).then((res) => {
    if (!res.ok) {
      throw Error(res.statusText);
    }
    return res.json();
  });
};
